import React, { useState } from 'react'
import { Menu, MenuItem, IconButton } from '@mui/material'

import { useTranslation } from 'react-i18next'

export const I18yMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const { t, i18n } = useTranslation()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    handleCloseMenu()
  }

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="primary"
        aria-label="menu"
        onClick={handleClick}
      >
        {i18n.language === 'en' ? '🇬🇧' : '🇸🇴'}
      </IconButton>

      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'language-button'
        }}
      >
        <MenuItem onClick={() => changeLanguage('en')}>
          🇬🇧 {t('english')}
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('so')}>
          🇸🇴 {t('Somali')}
        </MenuItem>

      </Menu>
    </>
  )
}
